import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://freksen.no';
const OG_IMAGE = 'https://avatars.githubusercontent.com/u/22099846?v=4';

interface SeoProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  structuredData?: object;
}

const Seo: React.FC<SeoProps> = ({ title, description, path, noindex = false, structuredData }) => {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Vemund Fredriksen" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {structuredData ? (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      ) : null}
    </Helmet>
  );
};

export default Seo;
